// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3fXPQ","left":"InfoRow_left__1MBjP"};